<template lang="pug">
inicio         
</template>
<script>
import inicio from "./view/index/app.vue"; 
export default {
  components: {
    inicio
     },
  data() {
    return { 
    };
  },
}

</script>
<style>
:root {
--Fondo1: #2C3E50;
--Fondo2: #5A6F87;
--Subfondo1 : #F7F8FA;
--Subfondo2: #34495E;
--Subfondo3: #5A6F87;


--tdFirst:#2C3E50;
--tdLast:#4A5E76;
--td:white;
--table:#5A6F87; 

--Btn1: #2C3E50 ; 
--Title : #34495E ;
}
</style>


